<ion-header translucent="true" mode="ios">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/welcome"></ion-back-button>
    </ion-buttons>
    <ion-title class="ion-text-center">Login</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true" class="login-page">
  <!-- Background with Illustration -->
  <div class="illustration-container">
    <img src="assets/logo/Mascot.png" alt="Delivery Illustration" class="illustration" />
  </div>
  
  <!-- Text Section -->
  <ion-grid class="text-container">
    <ion-row>
      <ion-col>
        <h2 class="title">Be a Delivery Rider</h2>
        <p class="subtitle">Get started with ubRYD</p>
      </ion-col>
    </ion-row>
  </ion-grid>

  <!-- Form Section -->
  <ion-card class="login-card">
    <form [formGroup]="loginForm">
      <ion-item>
        <!-- Country Code with Flag -->
        <div class="country-code">
          <img src="assets/country-flag/indianflag.webp" alt="India Flag" class="flag" />
          <span class="code">+91</span>
        </div>
      
        <!-- Phone Number Input -->
        <ion-input
          formControlName="phone"
          type="tel"
          placeholder="Enter Mobile Number"
          maxlength="10"
          class="phone-input"
        ></ion-input>
      </ion-item>

      <!-- Validation Error -->
      <ion-text *ngIf="loginForm.get('phone')?.invalid && loginForm.get('phone')?.touched">
        <!-- Required Field Error -->
        <small class="error" *ngIf="loginForm.get('phone')?.hasError('required')" color="danger">
          * Mobile number is required
        </small>
        <!-- Min Length Error -->
        <small class="error" *ngIf="loginForm.get('phone')?.hasError('minlength')" color="danger">
          * Enter a valid 10-digit number
        </small>
        <!-- Pattern Error -->
        <small class="error" *ngIf="loginForm.get('phone')?.hasError('pattern')" color="danger">
          * Only numeric values are allowed
        </small>
      </ion-text>

      <!-- Terms and Conditions -->
      <ion-item lines="none" class="terms">
        <ion-checkbox formControlName="termsAccepted" slot="start"></ion-checkbox>
        <ion-label>
          By signing up I agree to the
          <a href="#">Terms of use</a> and <a href="#">Privacy Policy</a>.
        </ion-label>
      </ion-item>

      <!-- Send OTP Button -->
      <ion-button
        expand="block"
        class="smpx-button"
        [disabled]="loginForm.invalid"
        (click)="getOtp()"
      >
        Send OTP
      </ion-button>
    </form>
  </ion-card>
</ion-content>
